createjs.ColorFilter.prototype.applyFilter = function(this: createjs.ColorFilter, ctx, x, y, width, height, targetCtx, targetX, targetY) {
    // this is the default behaviour because most filters access pixel data. It is overridden when not needed.
    targetCtx = targetCtx || ctx;
    if (targetX == null) { targetX = x; }
    if (targetY == null) { targetY = y; }
    // fast colorfilter for simple color switch
    if (this.redMultiplier === 0 && this.blueMultiplier === 0 && this.greenMultiplier === 0 && this.alphaMultiplier === 1) {
        ctx.save();
        ctx.globalCompositeOperation = "xor";
        ctx.fillStyle = `rgb(${this.redOffset}, ${this.greenOffset}, ${this.blueOffset})`;
        ctx.fillRect((ctx as any)._cacheOffsetX, (ctx as any)._cacheOffsetY, width, height);
        ctx.fillRect((ctx as any)._cacheOffsetX, (ctx as any)._cacheOffsetY, width, height);
        ctx.restore();
        return true;
    } else {
        try {
            let imageData = ctx.getImageData(x, y, width, height);
            if ((this as any)._applyFilter(imageData)) {
                targetCtx.putImageData(imageData, targetX, targetY);
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    }
};
